export const appConfig = {
  env: process.env.REACT_APP_ENV,
  ip: process.env.REACT_APP_API_ENDPOINT,
  imgServerip: process.env.REACT_APP_IMG_API_ENDPOINT,
  fbip: process.env.REACT_APP_FBAPI,
  fbappid: process.env.REACT_APP_FBAPPID,
};

export const momentDateFormat = "HH:mm ddd MM-DD-YYYY z";
